import blackboard from "./blackboard.svg";
import canvas from "./canvas.svg";
import confluence from "./confluence.svg";
import d2l from "./d2l.svg";
import dropbox from "./dropbox.svg";
import echovideo from "./echovideo.svg";
import ellucian from "./ellucian.svg";
import freshworks from "./freshworks.svg";
import googleCalendar from "./google-calendar.svg";
import googleDrive from "./google-drive.svg";
import kaltura from "./kaltura.svg";
import moodle from "./moodle.svg";
import oneDrive from "./one-drive.svg";
import outlookCalendar from "./outlook-calendar.svg";
import panopto from "./panopto.svg";
import servicenow from "./servicenow.svg";
import sharepoint from "./sharepoint.svg";
import teamdynamics from "./teamdynamics.svg";
import vimeo from "./vimeo.svg";
import wistia from "./wistia.svg";
import workday from "./workday.svg";
import yuja from "./yuja.svg";
import zendesk from "./zendesk.svg";

const INTEGRATIONS_ICONS = {
  blackboard,
  canvas,
  confluence,
  d2l,
  dropbox,
  echovideo,
  ellucian,
  freshworks,
  "google-calendar": googleCalendar,
  "google-drive": googleDrive,
  "microsoft-onedrive": oneDrive,
  kaltura,
  moodle,
  "outlook-calendar": outlookCalendar,
  panopto,
  servicenow,
  sharepoint,
  teamdynamics,
  vimeo,
  wistia,
  workday,
  yuja,
  zendesk,
} as const;

export type IntegrationIconKey = keyof typeof INTEGRATIONS_ICONS;
export default INTEGRATIONS_ICONS;
